import styles from "./VideoCallLobby.styles.scss";
import IconButton from "../IconButton/IconButton";
import Margin from "../Margin/Margin";
import {Row} from "../Layout/Layout";
import Button from "../Button/Button";
import {Body} from "../typography";
import Chat from "../chat";
import LinkButton from "../LinkButton/LinkButton";

const VideoCallLobby = ({isVideoEnabled,
                          isAudioEnabled,
                          videoRef,
                          remoteVideoRef,
                          isSpeaking,
                          onToggleVideo,
                          onToggleAudio,
                          onStartStream,
                          onEndStream,
                          isStreaming,
                          isPartnerStreaming,
                          contactInternalId,
                          roomId,
                          onToggleSidebar,
                          isSidebarOpen,
                          unreadMessagesCount,
                          arePermissionsEnabled,
                          message,
                          isConnectionAvailable
                        }) => {
  return <div className={styles.container}>
    <div className={styles.videoContainer}>
      {!arePermissionsEnabled && <div>
        <Body size="body1" color="#fff">Não foi possível acessar sua câmera.</Body>
        <Body size="body2" color="#fff">Por favor, verifique as configurações no seu navegador.</Body>
        <Margin top={16} />
        <Button title="Atualizar página" white onClick={() => window.location.reload()} />
      </div>}
      <div className={styles.messageOverlay}>{message}</div>
      <div style={{display: arePermissionsEnabled ? "flex" : "none"}}>
        <video muted={!isPartnerStreaming || !isStreaming} autoPlay playsInline ref={remoteVideoRef}
               className={[styles.video, (!isPartnerStreaming || !isStreaming) && styles.hidden].join(" ")}/>
        <video muted autoPlay playsInline ref={videoRef}
               className={[styles.video, styles.invertedVideo, (isPartnerStreaming && isStreaming) && styles.smallVideo].join(" ")}/>
      </div>
    </div>
    <div className={styles.toolbar} style={{display: arePermissionsEnabled ? "block" : "none"}}>
      <Margin vertical={16}>
        <Row horizontalCenter>
          <IconButton onClick={onToggleVideo} iconName={isVideoEnabled ? "video" : "video_off"} clear={isVideoEnabled} red={!isVideoEnabled} />
          <Margin left={16} />
          <IconButton onClick={onToggleAudio} iconName={isAudioEnabled ? "microphone" : "microphone_off"} clear={isAudioEnabled} red={!isAudioEnabled} accent={isSpeaking} />
          <Margin left={16} />
          <IconButton onClick={onToggleSidebar} iconName={"message"} clear={!isSidebarOpen} red={isSidebarOpen} badge={unreadMessagesCount} />
        </Row>
        <Margin top={16} />
        {!isStreaming && isConnectionAvailable && <Row horizontalCenter>
          <Button onClick={onStartStream} title="Iniciar chamada" white />
        </Row>}
        {!isStreaming && !isConnectionAvailable && <Row horizontalCenter>
          <Button disabled title="Conectando..." white />
        </Row>}
        <Margin top={4} />
        {isStreaming && !isPartnerStreaming && <Row horizontalCenter>
          <Body size="body1" color="#fff" center>Aguardando o seu contato se conectar...</Body>
        </Row>}
        {isStreaming && isPartnerStreaming && <Row horizontalCenter>
          <Button onClick={onEndStream} title="Encerrar chamada" white onPress={onEndStream} />
        </Row>}
      </Margin>
    </div>
    {isSidebarOpen && <div className={styles.sidebarOverlay}>
      <div className={styles.sidebar}>
        <Chat contactInternalId={contactInternalId} roomId={roomId}/>
        <Margin horizontal={16} vertical={16}>
          <LinkButton color="#fff" leftIconName='close' text='Fechar' onClick={onToggleSidebar}/>
        </Margin>
      </div>
    </div>}
  </div>
};

export default VideoCallLobby;



// WEBPACK FOOTER //
// ./components/VideoCallLobby/VideoCallLobby.js